import React from "react";
import { useParams } from "react-router-dom";
import { DealFormPage } from "./AddDealPage";

// Edit Deal page: reuses the Add Deal form in edit mode, loading the existing
// deal (by :id from the URL) and prepopulating every field.
function EditDealPage() {
  const { id } = useParams();
  return <DealFormPage mode="edit" dealId={id} />;
}

export default EditDealPage;
